document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // 1. CAROSELLO: DRAG-TO-SCROLL & FRECCE
  // ==========================================
  const trackContainers = document.querySelectorAll('.koji-packs-track-container');

  trackContainers.forEach(container => {
    const track = container.querySelector('.koji-packs-track');
    const prevBtn = container.querySelector('.koji-packs-prev');
    const nextBtn = container.querySelector('.koji-packs-next');

    if (prevBtn && nextBtn && track) {
      const scrollAmount = () => {
        const item = track.querySelector('.koji-pack-item');
        return item ? (item.offsetWidth + parseFloat(window.getComputedStyle(track).gap || 20)) * 1.5 : 400;
      };

      nextBtn.addEventListener('click', () => { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
      prevBtn.addEventListener('click', () => { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    }

    if (track) {
      let isDown = false; let startX; let scrollLeft; let isDragging = false; 

      track.addEventListener('mousedown', (e) => {
        if(e.target.closest('.koji-artist-btn') || e.target.closest('.koji-pack-back-card')) return;
        
        isDown = true;
        track.style.scrollBehavior = 'auto'; track.style.scrollSnapType = 'none'; 
        startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft; isDragging = false;
      });

      track.addEventListener('mouseleave', () => {
        isDown = false; track.style.scrollBehavior = 'smooth'; track.style.scrollSnapType = 'x mandatory';
      });

      track.addEventListener('mouseup', () => {
        isDown = false; track.style.scrollBehavior = 'smooth'; track.style.scrollSnapType = 'x mandatory';
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return; 
        const x = e.pageX - track.offsetLeft; 
        const walk = (x - startX) * 2; 
        
        // FIX BUG USABILITÀ: Impedisce che piccoli movimenti del mouse blocchino il clic sul link (soglia di 5px)
        if (Math.abs(walk) > 5) {
          isDragging = true;
          e.preventDefault(); 
        }
        
        track.scrollLeft = scrollLeft - walk;
      });

      const links = track.querySelectorAll('.koji-pack-card');
      links.forEach(link => {
        link.addEventListener('click', (e) => { 
          if (isDragging) e.preventDefault(); 
        });
      });
    }
  });

  // ==========================================
  // 2. FUNZIONE ARTISTA (TOOLTIPS)
  // ==========================================
  const artistBtns = document.querySelectorAll('.koji-artist-btn');
  
  artistBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); 
      const targetId = this.getAttribute('data-artist-id');
      const tooltip = document.getElementById(targetId);
      
      document.querySelectorAll('.koji-artist-tooltip').forEach(tt => {
        if(tt.id !== targetId) {
          tt.classList.remove('is-active');
          const relatedBtn = document.querySelector(`[data-artist-id="${tt.id}"]`);
          if(relatedBtn) relatedBtn.setAttribute('aria-expanded', 'false');
        }
      });

      if (tooltip) {
        const isActive = tooltip.classList.toggle('is-active');
        this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  });

  // Chiusura tooltip ai click esterni
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.koji-artist-btn') && !e.target.closest('.koji-artist-tooltip')) {
      document.querySelectorAll('.koji-artist-tooltip').forEach(tt => tt.classList.remove('is-active'));
      document.querySelectorAll('.koji-artist-btn').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }
  });

  // ==========================================
  // 3. POPUP COLLABORAZIONE E CHIUSURA ACCESSIBILE (ESC)
  // ==========================================
  const collabTriggers = document.querySelectorAll('.koji-collab-trigger');
  const collabModal = document.getElementById('koji-collab-modal');
  const collabClose = document.querySelector('.koji-collab-close');

  if (collabModal) {
    if (collabModal.parentNode !== document.body) {
        document.body.appendChild(collabModal);
    }

    collabTriggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        collabModal.classList.add('is-active');
        // Opzionale ma consigliato per WCAG: sposta il focus dentro la modale
        if (collabClose) collabClose.focus();
      });
    });

    if (collabClose) {
      collabClose.addEventListener('click', (e) => {
        e.preventDefault();
        collabModal.classList.remove('is-active');
      });
    }

    collabModal.addEventListener('click', (e) => {
      if (e.target === collabModal) collabModal.classList.remove('is-active');
    });
  }

  // ACCESSIBILITÀ: Permette la chiusura con il tasto ESC per Tooltip e Modal
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      // Chiudi Modale
      if (collabModal && collabModal.classList.contains('is-active')) {
        collabModal.classList.remove('is-active');
      }
      
      // Chiudi Tooltips
      document.querySelectorAll('.koji-artist-tooltip.is-active').forEach(tt => {
        tt.classList.remove('is-active');
        const relatedBtn = document.querySelector(`[data-artist-id="${tt.id}"]`);
        if (relatedBtn) {
          relatedBtn.setAttribute('aria-expanded', 'false');
          relatedBtn.focus(); // Riporta il focus al pulsante dell'artista per accessibilità
        }
      });
    }
  });

});